import * as api from '../../../clients/veranstaltungen';

import {Action} from '@ngrx/store';

export const POST_FUNKPROTOKOLL_VORLAGE_KOPIEREN_ADMIN = '[VeranstaltungenModul] PostFunkprotokollVorlageKopierenAdmin laden';
export const POST_FUNKPROTOKOLL_VORLAGE_KOPIEREN_ADMIN_AUSFUEHREN = '[VeranstaltungenModul] PostFunkprotokollVorlageKopierenAdmin ausführen';
export const POST_FUNKPROTOKOLL_VORLAGE_KOPIEREN_ADMIN_ERFOLGREICH = '[VeranstaltungenModul] PostFunkprotokollVorlageKopierenAdmin laden erfolgreich';
export const POST_FUNKPROTOKOLL_VORLAGE_KOPIEREN_ADMIN_FEHLER = '[VeranstaltungenModul] PostFunkprotokollVorlageKopierenAdmin Ladefehler';
export const POST_FUNKPROTOKOLL_VORLAGE_KOPIEREN_ADMIN_NICHT_AUSGEFUEHRT = '[VeranstaltungenModul] PostFunkprotokollVorlageKopierenAdmin nicht ausgeführt (evtl. Offline)';


export class PostFunkprotokollVorlageKopierenAdminAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_KOPIEREN_ADMIN;
        constructor(public funkprotokollVorlageRequest: api.FunkprotokollVorlageRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageKopierenAdminAusfuehrenAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_KOPIEREN_ADMIN_AUSFUEHREN;
        constructor(public funkprotokollVorlageRequest: api.FunkprotokollVorlageRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageKopierenAdminErfolgreichAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_KOPIEREN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.FunkprotokollVorlageIdentifier, public funkprotokollVorlageRequest: api.FunkprotokollVorlageRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageKopierenAdminFehlerAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_KOPIEREN_ADMIN_FEHLER;
        constructor(public payload: any, public funkprotokollVorlageRequest: api.FunkprotokollVorlageRequest, public optPayload: any = null) {}
    }
export class PostFunkprotokollVorlageKopierenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_FUNKPROTOKOLL_VORLAGE_KOPIEREN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VeranstaltungenCommandFunkprotokollVorlageKopierenAdminActions =
    PostFunkprotokollVorlageKopierenAdminAction
    | PostFunkprotokollVorlageKopierenAdminAusfuehrenAction
    | PostFunkprotokollVorlageKopierenAdminErfolgreichAction
    | PostFunkprotokollVorlageKopierenAdminFehlerAction
    | PostFunkprotokollVorlageKopierenAdminNichtAusgefuehrtAction
    ;
